import {
   ADD_SALE_RETURN_INVOICE,
   GET_SALE_RETURN_INVOICES,
   GET_SALE_RETURN_INVOICES_FOR_DAYBOOK,
   GET_SALE_RETURN_INVOICE,
   GET_SALE_RETURN_INVOICES_TRANSACTIONS,
   UPDATE_SALE_RETURN_INVOICE,
   DELETE_SALE_RETURN_INVOICE,
   LAST_BILL_SALE_RETURN_INVOICE,
   GET_LAST_SALE_RETURN_DAYBOOK,
   SET_LOADING,
   GET_ONE_SALE_RETURN,
   EMPTY_ONE_SALE_RETURN,
   GET_SALE_RETURN_INVOICE_WITH_PREV_AND_NEXT,
   GET_SALE_RETURN_INVOICE_PREV_AND_NEXT,
   GET_SALES_STOCKS,
} from '../types';

const initialState = {
   list: [],
   single: null,
   totalCount: 0,
   lastBill: null,
   isLoading: false,
   lastSaleDaybook: null,
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   saleReturnData: null,
   prevAndNext: null,
   stocks: [],
};

const reducer = (state = initialState, action) => {
   const { type, payload, totalCount } = action;

   switch (type) {
      case SET_LOADING:
         return {
            ...state,
            isLoading: payload,
         };
      case EMPTY_ONE_SALE_RETURN:
         return {
            ...state,
            single: payload,
         };
      case GET_SALE_RETURN_INVOICES:
         return {
            ...state,
            list: payload.data,
            totalCount: totalCount,
            isLoading: false,
            pagination: action.payload.pagination,
         };

      case GET_SALE_RETURN_INVOICES_FOR_DAYBOOK:
         return {
            ...state,
            listfordaybook: payload.data,
            totalCountfordaybook: totalCount,
            isLoadingfordaybook: false,
            paginationfordaybook: action.payload.pagination,
         };

      case GET_SALE_RETURN_INVOICE:
         return {
            ...state,
            single: payload || initialState.single,
            isLoading: false,
         };

      case GET_SALE_RETURN_INVOICES_TRANSACTIONS:
         return {
            ...state,
            data: payload.data || initialState.single,
            isLoading: false,
         };

      case UPDATE_SALE_RETURN_INVOICE:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
            isLoading: false,
         };

      case ADD_SALE_RETURN_INVOICE:
         return {
            ...state,
            list: [payload, ...state.list],
            totalCount: state.totalCount + 1,
            isLoading: false,
         };

      case DELETE_SALE_RETURN_INVOICE:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
            totalCount: state.totalCount - 1,
            isLoading: false,
         };

      case LAST_BILL_SALE_RETURN_INVOICE:
         return {
            ...state,
            lastBill: payload,
         };

      case GET_LAST_SALE_RETURN_DAYBOOK:
         return {
            ...state,
            lastSaleDaybook: payload,
         };

      case GET_ONE_SALE_RETURN:
         return { ...state, single: payload };

      case GET_SALES_STOCKS:
         return { ...state, stocks: payload };

      case GET_SALE_RETURN_INVOICE_WITH_PREV_AND_NEXT:
         return {
            ...state,
            saleReturnData: { data: payload.data, pagination: payload.pagination, totalCount: payload.totalCount },
         };

      case GET_SALE_RETURN_INVOICE_PREV_AND_NEXT:
         return {
            ...state,
            prevAndNext: payload,
         };

      default:
         return state;
   }
};

export default reducer;
